'use strict';
import customModal from './modal';
import page from './page';
import util from './util';
import formPrepare from './pages/checkout/formPrepare';
import validator from './validator';
import validatorEmea from './validator';
import analytics from './analytics';
var login = {
	/**
	 * @private
	 * @function
	 * @description init events for the loginPage
	 */
	init: function () {
		 //o-auth binding for which icon is clicked
		 $(document).on('click', '.oAuthIcon', function () {
			 analytics.socialLoginEvent(this.id);
            $(this).parents('form').find('.OAuthProvider').val(this.id);
			$(this).parents('form').find('#socialRedirectUrl').val(window.location.href);
        });
		
		 //o-auth binding for which icon is clicked
		 $(document).on('click', '.oAuthIconApple', function () {
            $(this).parents('form').find('.OAuthProvider').val(this.id);
        });

		//toggle the value of the rememberme checkbox
		$('#dwfrm_login_rememberme').bind('change', function () {
			if ($('#dwfrm_login_rememberme').attr('checked')) {
				$('#rememberme').val('true');
			} else {
				$('#rememberme').val('false');
			}
		});
	},
	wishlistAjaxLogin: function (form) {
		var _this = this;
		$(form).submit(function (event) {
			event.preventDefault();
			var data = {}
			$(form).find('.data-field, .input-field input').each(function () {
				var name = $(this).attr('name');
				var value = $(this).val();
				data[name] = value;
			})
			$('.login-wrapper .ajax-loader').show();
			$.ajax({
				type: 'post',
				url: $(form).attr('action'),
				data: data
			}).done(function (response) {
				if (response !== '' && response !== null) {
					if (response.success) {
						window.location.href = response.url;
					} else {
						$('#login-modal .login-box').replaceWith($(response).find('.login-main'));
						validator.initForm('form[id$="dwfrm_login"]');
						_this.wishlistAjaxLogin('form[id$="dwfrm_login"]');
						$('.login-wrapper .ajax-loader').hide();
					}
				} else {
					location.reload();
					if ($('.pt_articles_listing').length) {
						var offsetTop = '';
						if ($('.header-wrapper').css('position') === "fixed") {
							offsetTop = $('#main').offset().top;
						} else {
							offsetTop = $('#main').offset().top - $('.header-wrapper').height();
						}
						$(window).scrollTop(offsetTop);
					}
				}
			});
		});
	},
	wishListButtonEnableDisable: function () {
		//Guest Checkout
		if ($('.login-wrapper').length) {
			var emailButton2 = $('.login-wrapper button#login'),
				emailInput2 = $('.login-wrapper input[type="email"]'),
				password = $('.login-wrapper input[type="password"]');
			$(emailInput2, password).on('blur', function () {
				var email_regx = validator.regex.email;
				if (email_regx.test(emailInput2.val())) {
					if (!password.val().length || login.enableDisableSubmitButton(emailButton2)) {
						emailButton2.prop('disabled', 'disabled');
					} else {
						emailButton2.prop('disabled', false);
					}
				} else {
					emailButton2.prop('disabled', 'disabled');
				}
			});
			if (!emailInput2.val().length || !password.val().length) {
				emailButton2.prop('disabled', 'disabled');
			}
		}
	},
	enableDisableSubmitButton: function (el) {
		var $saveBtn = $(el).closest('form').find('button[type="submit"]');
		var hasError = $saveBtn.closest('form').find('span.error');
		if (hasError.length) {
			return true
		} else {
			return false;
		}
	}
}

//Reset Password
$(document).on('click', '.password-reset', function (e) {
	e.preventDefault();
	var ajaxUrl;
	ajaxUrl = util.appendParamToURL(Urls.securePasswordReset, 'format', 'ajax')
	$.ajax({
		type: 'GET',
		url: ajaxUrl
	}).done(function (response) {
		if (response !== '' && response !== null && response.error === undefined) {
			customModal.createCustomModal('forgot-password-modal', '#modal-custom-placeholder');
			$('.forgot-password-modal .modal-body').html(response);
			validator.initForm('.forgot-password-modal form');

			var $requestPasswordForm = $('[name$="_requestpassword"]'),
				$submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');

			$($submit).on('click', function (e) {
				if (!$requestPasswordForm.valid()) {
					return;
				}
				e.preventDefault();
				var data = $requestPasswordForm.serialize();
				// add form action to data
				data += '&' + $submit.attr('name') + '=';
				// make sure the server knows this is an ajax request
				if (data.indexOf('ajax') === -1) {
					data += '&format=ajax';
				}
				$.ajax({
					type: 'POST',
					url: $requestPasswordForm.attr('action'),
					data: data,
					success: function (response) {
						if (typeof response === 'object' &&
							!response.success &&
							response.error === 'CSRF Token Mismatch') {
							page.redirect(Urls.csrffailed);
						} else if (typeof response === 'string') {
							$('.forgot-password-modal .forgot-password-container').html(response);
							$('.forgot-password-modal .modal-body').scrollBox();
						}
					},
					failure: function () {
						$('.forgot-password-modal .forgot-password-container').html('<h1>' + Resources.SERVER_ERROR + '</h1>');
						$('.forgot-password-modal .modal-body').scrollBox();
					}
				});
			});

			$('.forgot-password-modal .modal-body').scrollBox();
			validatorEmea.changeFieldValidation();
		}
	});
});

export default login;

///Login Greetings
if (window.User.isCustomerAuthenticated != false || window.User.isRegistered == true) {
	var myDate = new Date();
	var hrs = myDate.getHours();
	var mins = myDate.getMinutes();
	var time;
	var greeting;

	mins = ('0' + mins).slice(-2);
	time = hrs + mins;
	time = Number(time);

	if (time >= 300 && time <= 1159) {
		greeting = window.Resources.GREETINGS_MORNING;
	} else if (time >= 1200 && time <= 1700) {
		greeting = window.Resources.GREETINGS_AFTERNOON;
	} else {
		greeting = window.Resources.GREETINGS_EVENING;
	}

	$('#login-greetings').text(greeting);
	$('.menu-greeting #login-greetings').text(greeting);
}